import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  values: any;
  estado: any = "";
  periodoini: any = "";
  periodofin: any = "";
  comentarios: any = "";
  btnStatus: boolean = true;
  bofuenteSeleccionada: boolean = false;
  private notificationService: NotificationService;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.notificationService = injector.get<NotificationService>(NotificationService);
  }

  ngOnInit(): void {
    //This is intentional
    this.bofuenteSeleccionada = false;
    if (this.data.subdomain == "bcra"){
      this.bofuenteSeleccionada = true;
    }
  }

  onNoClick(): void {
    const res = {
      status: false,
      value: null
    }
    this.dialogRef.close(res);
  }

  onSubmit(): void {
    if (this.bofuenteSeleccionada){
      if (this.periodoini.length == 0 && this.periodofin.length ==0)
        {
          this.notificationService.showError("¡ Debe ingresar información de Períodos !")
          return;
        }
      if (this.periodoini >= this.periodofin)
        {
          this.notificationService.showError("¡ Período desde tiene que ser mayor a Período hasta !")
          return;
        }
      if (this.periodoini.length < 6 || this.periodofin.length < 6)
        {
          this.notificationService.showError("¡ Períodos con formato no válidos !")
          return;
        }
    }
    const res = {
      status: true,
      value: this.values,
      estado: "NOC",
      periodoini: this.periodoini,
      periodofin: this.periodofin,
      comentarios: this.comentarios
    }
    this.dialogRef.close(res);
  }

  addValue(data) {
    console.log('data', data);
    this.btnStatus = (data === "");
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
